<ion-button
  expand="block"
  class="icon-button"
  [disabled]="isDisabled"
  [ngClass]="{ disabled: isDisabled }"
  (click)="clickAddItem()"
>
  <div class="icon-container" [ngClass]="{ disabled: isDisabled }">
    <ion-icon
      slot="start"
      class="icon"
      [ngClass]="{ disabled: isDisabled }"
      [src]="IMAGES.ADD_WHITE"
    ></ion-icon>
  </div>
  {{ DISP_CONSTANTS.ADD_BUTTON_TEXT }}
</ion-button>
